import auth from '@feathersjs/authentication-client'
import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import io from 'socket.io-client'
import _Vue from 'vue'

const socket = io(`//${process.env.VUE_APP_HOST}:${process.env.VUE_APP_PORT}`)
const client = feathers()

client.configure(auth({
  cookie: 'metabola-cookie',
  storageKey: 'metabola-jwt',
  storage: window.localStorage,
}))

// Set up Socket.io client with the socket
client.configure(socketio(socket))

export { client }

export default {
  install(Vue: typeof _Vue, name = '$feathers') {
    Object.defineProperty(Vue.prototype, name, { value: client })
  },
}
